import styled from '@emotion/styled';
import { useContext } from 'react';
import { buyerUserContext } from 'application/contexts/useBuyerUser';
import { RequestMeetList } from './RequestMeetList';
import { PageTitle } from 'ui/components/elements/PageTitle/PageTitle';
import { AboutService } from 'ui/components/buyer/features/AboutService';
import { MeetingList } from './MeetingList';
import { StepFlow } from './StepFlow';
// import { TopOfferBuyers } from './TopOfferBuyers';
import { AttentionCard } from './AttentionCard';
import { QA } from './QA';
import { mqUser } from 'utils/responsive';
import { CopyInvitationCodeButton } from 'ui/components/common/features/CopyInvitationCodeButton/CopyInvitationCodeButton';

const Wrapper = styled.div`
    padding: 18px 50px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    text-align: left;
    background-color: #f8f9fd;
    height: auto;
    min-height: calc(100vh - var(--height-pc-header));
    overflow-y: auto;

    ${mqUser('SP')} {
        padding: 18px 15px;
    }
`;

const tabs = ['企業情報の登録', 'チャットの開通', '面談日の設定', '公開（非公開）の切り替え', 'アンケートの入力'];

const descriptions: { [key: string]: string[] } = {
    企業情報の登録: [
        '企業情報を登録することにより、仲介会社からのオファーに対しての承諾、チャットでのやり取りが可能となります。',
        '質問、不安の解消のためにも企業情報を登録しましょう。',
    ],
    チャットの開通: [
        'チャットが開通すると、仲介会社と直接やり取りを行うことができます。',
        '複数の仲介会社とやりとりを行い比較をすることで、情報の整理やベストなアドバイザー探しに役立てましょう。',
    ],
    面談日の設定: ['仲介会社とのチャットページにて、面談日の設定、管理を行うことが可能です。'],
    '公開（非公開）の切り替え': [
        '公開状態は、仲介会社からのオファーを受ける状態です。非公開は、仲介会社側に案件が非公開となりオファーを受けることができない状態です。公開、非公開は自由に変更が可能です。',
    ],
    アンケートの入力: [
        '仲介会社とのチャットや面談後に、アンケートのご回答をお願いいたします。',
        'アンケートにより、優良な仲介会社の選定に役立てることが可能となります。',
    ],
};

export const Dashboard: React.FC = () => {
    const { user, meetingDateSetMatchList, offerList, existsUnreadMsg, isMeetingDateNotSet } =
        useContext(buyerUserContext);

    const buyerName = user?.buyer?.name || '買い手企業';
    let attentionList = [];
    if (offerList.length > 0) {
        attentionList.push({
            text: `オファーが${offerList.length}件届いています。`,
            link: '/buyer/match/',
        });
    }
    if (existsUnreadMsg) {
        attentionList.push({
            text: '未読のメッセージがあります。',
            link: '/buyer/message/',
        });
    }
    if (isMeetingDateNotSet) {
        attentionList.push({
            text: '面談日が未設定の企業があります。「メッセージ」から面談日を設定してください。',
            link: '/buyer/message/',
        });
    }

    return (
        <Wrapper>
            {attentionList.length > 0 && <AttentionCard attentionList={attentionList} />}
            <PageTitle title={`${buyerName}様マイページ`} />
            {user?.invitation_code && <CopyInvitationCodeButton invitationCode={user.invitation_code} />}
            <AboutService tabs={tabs} descriptions={descriptions} />
            <StepFlow />
            <RequestMeetList />
            <MeetingList matches={meetingDateSetMatchList} />
            {/* <TopOfferBuyers companies={buyers} /> */}
            <QA />
        </Wrapper>
    );
};
